<template>
    <li @click="checkboxSelect" class="this-checkbox-item">
        <span class="this-checkbox">
            <i v-if="!checked" class="fa fa-square-o"></i>
            <i class="fa fa-check-square-o"></i>
        </span>
        <span class="this-text">{{title}}</span>
    </li>
</template>

<script>
export default {
    name: "CheckboxComponent",
    props: {
        title: {
            type: String,
            required: true
        }
    },
    data(){
        return {
            checked: false
        }
    },
    methods: {
        checkboxSelect(e){
            this.checked = !this.checked
            const output = {
                "value":this.title
            }
            this.$emit('checkboxSelected',  JSON.stringify(output), this.checked)
        }
    }
}
</script>

<style lang="scss" scoped>
    .this-checkbox-item {
        display: flex;
        align-items: center;
        padding: 5px;

        &:hover {
            cursor: pointer;
        }

        &+.this-checkbox-item {
            border-top: 1px solid #f4f4f4;
        }
    }

    .this-checkbox{
        margin-right: 10px;
        width: 20px;
        height: 20px;
        display: block;
        overflow: hidden;

        &:hover {
            cursor: pointer;
        }
    }

    .fa {
        display: block;
        width: 20px;
        height: 20px;
        font-size: 20px;
        color: lighten(black, 70%);
    }

    .fa-check-square-o{
        color: #ffb946;
    }

    .this-text{
        font-size: 12px;
    }
</style>




// WEBPACK FOOTER //
// src/components/pages/kitchen/ArnergyReportComponents/CheckboxComponent.vue